import { useRouter } from 'next/router'

import appConfig from '~/config/app'
import { isAuthenticated } from '~/auth/slices/auth.slice'

import { useSubscriptionApplicabilityQuery } from '~/redux/apis/payment-api'
import { useAppSelector } from '~/redux/hooks'

import { isSubscriptionRequiredOnUser } from '~/redux/slices/user'
import { AppLanguage } from '~/types/locale'

export default function useSubscriptionIsRequired(props: { urlPath?: string; considerPermissions?: boolean } = {}): {
  isSubscriptionRequired: boolean
  isLoading: boolean
} {
  const { urlPath, considerPermissions = true } = props
  const authenticated = useAppSelector(isAuthenticated)
  const locale = useRouter()?.locale
  const subscriptionIsRequiredOnUser = useAppSelector(isSubscriptionRequiredOnUser(urlPath, considerPermissions))

  const { data: isSubscriptionApplicable = false, isLoading } = useSubscriptionApplicabilityQuery(undefined, {
    skip: authenticated || appConfig.isSchoolPlatform,
  })

  // The `!authenticated && isSubscriptionApplicable` arm reads the applicability API rather than the
  // user object, so it is NOT covered by the isSubscriptionRequiredForUser gate and has to be
  // short-circuited here too — otherwise logged-out visitors would still be treated as needing a
  // subscription in the school platform.
  const isSubscriptionRequired =
    !appConfig.isSchoolPlatform &&
    !!locale &&
    locale !== AppLanguage.UA &&
    (subscriptionIsRequiredOnUser || (!authenticated && isSubscriptionApplicable))

  return {
    isSubscriptionRequired,
    isLoading: authenticated ? false : isLoading, // If authenticated, query is skipped so no loading
  }
}
